"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./_useLocale-CpTrqBDt.js");require("react"),require("./IntlContext-DcFt0tgW.js"),exports.useLocale=e.useLocale;
